import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { shouldFetchList } from '../../../lib/utils';
import targetDeploymentActions from '../../../actions/targetDeployments';
import TargetDeploymentPage from './TargetDeploymentPage';

class TargetDeploymentContainer extends React.Component {
  componentDidMount() {
    const {
      match,
      targetDeployments,
      fetchTargetDeployments,
    } = this.props;
    const marketId = get(match, 'params.marketId');
    if (marketId) {
      if (shouldFetchList(marketId, targetDeployments)) fetchTargetDeployments(marketId);
    }
  }

  render() {
    const { handleBackClick } = this.props;
    return (
      <TargetDeploymentPage handleBackClick={handleBackClick} />
    );
  }
}

function mapStateToProps({
  markets, targetDeployments,
}) {
  return {
    market: markets.selectedMarket,
    targetDeployments: targetDeployments.targetDeployments,
    targetDeploymentsLoading: targetDeployments.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...targetDeploymentActions,
  }, dispatch);
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetDeploymentContainer));
